import React, {Fragment, useState} from "react";
import {Col, Form, Input, Row} from "antd";
import {FormattedMessage} from "react-intl";
import {Channel} from "@models/channel";
import ChannelsSelection from "@components/channels/Selection";
import {SelectionMode} from '@models';

interface ChannelProps {
  selectedChannel: Channel | null;
  form: any;
}

const WidgetItemChannelSelection: React.FC<ChannelProps> = props => {
  const {form, selectedChannel} = props;
  const [channel, setChannel] = useState(selectedChannel || null);

  const onSelectChannel = (selected: Channel) => {
    setChannel(selected);
    form.setFieldsValue({
      channel: selected,
      channel_id: selected.id,
    });
  };

  return (
    <Fragment>
      <Form.Item className={"no-label"}>
        {form.getFieldDecorator("channel", {
          initialValue: channel
        })(
          <Input type={`hidden`}/>
        )}
      </Form.Item>
      <Row gutter={24}>
        <Col span={24}>
          <Form.Item label={<FormattedMessage id="app.select_channel" defaultMessage={`Select Channel`}/>}>
            {form.getFieldDecorator("channel_id", {
              initialValue: channel ? channel.id : null,
              rules: [
                {
                  required: true,
                  message: (
                    <FormattedMessage
                      id="app.channel_is_required"
                      defaultMessage={`Select channel!`}
                    />
                  )
                }
              ]
            })(<Input type={`hidden`}/>)}
            <ChannelsSelection
              mode={SelectionMode.DEFAULT}
              onChange={onSelectChannel as any}
              initialValue={channel}
            />
          </Form.Item>
        </Col>
      </Row>
    </Fragment>
  );
};

export default WidgetItemChannelSelection;
